module.exports = __webpack_public_path__ + "static/media/software_engineer_intern certificate.dcff966a.png";